import { render, staticRenderFns } from "./ExternalLink.vue?vue&type=template&id=f43854c0&scoped=true&"
import script from "./ExternalLink.vue?vue&type=script&lang=ts&"
export * from "./ExternalLink.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalLink.vue?vue&type=style&index=0&id=f43854c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43854c0",
  null
  
)

export default component.exports